export default "__VITE_ASSET__b898d811__"